<p>Financial Assurance for the Organization will be marked Released by this side effect.</p>
<div class="grid-x">
  <div class="cell small-12 medium-12 large-12">
    <label for="organizatioNId">
      Retrieve Organization Id from context location:
    </label>
  </div>
  <div class="cell small-12 medium-12 large-12">
    <input type="text" id="organizationId" [(ngModel)]="_seConfiguration.organizationId" placeholder="$..." />
  </div>
  <div class="small-10 medium-10 large-10">
    <label>Recorded Release Date Values will be stored in:</label>
  </div>
  <div class="small-2 medium-2 large-2">
    <button class="button" (click)="add()">Add</button>
  </div>
  <div class="cell small-6 medium-6 large-6 bold">
    Check #
  </div>
  <div class="cell small-6 medium-6 large-6 bold">
    Release Date:
  </div>
  @if (dateSources.length > 0) {
    @for (source of dateSources; track source; let i = $index) {
      <div class="cell small-5 medium-5 large-5 padding-right">
        <input type="text" [id]="'check' + i" [(ngModel)]="source.check" placeholder="$..." />
      </div>
      <div class="cell small-5 medium-5 large-5 padding-left">
        <input type="text" [id]="'date' + i" [(ngModel)]="source.date" placeholder="$.." />
      </div>
      <div class="cell small-2 medium-2 large-2 padding-left">
        <button class="button" (click)="delete(i)">Delete</button>
      </div>
    }
  } @else {
    <div class="cell small-12 medium-12 large-12">
      No sources have been configured
    </div>
  }
</div>



